export const monitoringConstants = {
  GET_IP_ADDRESS_MONITORING_LIST_REQUEST:
    "GET_IP_ADDRESS_MONITORING_LIST_REQUEST",
  GET_IP_ADDRESS_MONITORING_LIST_SUCCESS:
    "GET_IP_ADDRESS_MONITORING_LIST_SUCCESS",
  GET_IP_ADDRESS_MONITORING_LIST_FAILURE:
    "GET_IP_ADDRESS_MONITORING_LIST_FAILURE",

  GET_COUNTRY_CODE_LIST_REQUEST: "GET_COUNTRY_CODE_LIST_REQUEST",
  GET_COUNTRY_CODE_LIST_SUCCESS: "GET_COUNTRY_CODE_LIST_SUCCESS",
  GET_COUNTRY_CODE_LIST_FAILURE: "GET_COUNTRY_CODE_LIST_FAILURE",

  GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_REQUEST:
    "GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_REQUEST",
  GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_SUCCESS:
    "GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_SUCCESS",
  GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_FAILURE:
    "GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_FAILURE",

  GET_TRANSACTION_MONITORING_REQUEST: "GET_TRANSACTION_MONITORING_REQUEST",
  GET_TRANSACTION_MONITORING_SUCCESS: "GET_TRANSACTION_MONITORING_SUCCESS",
  GET_TRANSACTION_MONITORING_FAILURE: "GET_TRANSACTION_MONITORING_FAILURE",

  GET_FEES_MONITORING_LIST_REQUEST: "GET_FEES_MONITORING_LIST_REQUEST",
  GET_FEES_MONITORING_LIST_SUCCESS: "GET_FEES_MONITORING_LIST_SUCCESS",
  GET_FEES_MONITORING_LIST_FAILURE: "GET_FEES_MONITORING_LIST_FAILURE",

  GET_WEB_STORES_MONITORING_LIST_REQUEST: "GET_WEB_STORES_MONITORING_LIST_REQUEST",
  GET_WEB_STORES_MONITORING_LIST_SUCCESS: "GET_WEB_STORES_MONITORING_LIST_SUCCESS",
  GET_WEB_STORES_MONITORING_LIST_FAILURE: "GET_WEB_STORES_MONITORING_LIST_FAILURE",

  GET_USER_CREDIT_SCORE_MONITORING_LIST_REQUEST: "GET_USER_CREDIT_SCORE_MONITORING_LIST_REQUEST",
GET_USER_CREDIT_SCORE_MONITORING_LIST_SUCCESS: "GET_USER_CREDIT_SCORE_MONITORING_LIST_SUCCESS",
GET_USER_CREDIT_SCORE_MONITORING_LIST_FAILURE: "GET_USER_CREDIT_SCORE_MONITORING_LIST_FAILURE",

};
